import gql from "graphql-tag";

export const REMOVE_REPORT = gql`
  mutation ($reportId: ID!) {
    removeReport(reportId: $reportId) {
      _id
    }
  }
`;
